import React, { useEffect, useState } from 'react';
import api from '../services/api';

const ConsultantAssign = () => {
  const [users, setUsers] = useState([]);
  const [consultants, setConsultants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedConsultant, setSelectedConsultant] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      try {
        // fetch all users and derive lists client-side
        const res = await api.get('/users/list'); // returns all users (admins included for admin requester)
        const all = res.data || [];
        setUsers(all); // users list = all accounts (incl Admin & Consultant)
        // consultants list = role === 'Consultant' OR Admin (Admins should be selectable as consultants)
        setConsultants(all.filter(u => String(u.role).toLowerCase() === 'consultant' || String(u.role).toLowerCase() === 'admin'));
      } catch (err) {
        console.error('Failed to load lists', err);
        setError(err?.response?.data?.message || 'Failed to load lists');
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, []);

  const handleAssign = async () => {
    if (!selectedUser || !selectedConsultant) return setError('Select user and consultant');
    setAssigning(true);
    setError('');
    try {
      // call assign endpoint
      await api.post('/consultants/assign', { userId: selectedUser, consultantId: selectedConsultant });
      // refresh users list so UserList/this component reflect the assignment
      const res = await api.get('/users/list');
      const all = res.data || [];
      setUsers(all);
      setConsultants(all.filter(u => String(u.role).toLowerCase() === 'consultant' || String(u.role).toLowerCase() === 'admin'));
      alert('Assigned successfully');
    } catch (err) {
      console.error('Assign failed', err);
      setError(err?.response?.data?.message || 'Assign failed');
    } finally {
      setAssigning(false);
    }
  };

  return (
    <div>
      <h4>Assign Consultant to User</h4>
      {loading && <div>Loading...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}

      <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600 }}>Users</div>
          <div style={{ maxHeight: 240, overflow: 'auto', border: '1px solid #eee', padding: 8 }}>
            {users.length === 0 && <div>No users found</div>}
            {users.map(u => (
              <div key={u.id} style={{ padding: 6, borderBottom: '1px solid #f2f2f2', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 600 }}>{u.name || u.email} <span style={{ fontSize: 12, color: '#888', marginLeft: 8 }}>#{u.id}</span></div>
                  <div style={{ fontSize: 12, color: '#666' }}>
                    {u.email} {u.tin ? `• TIN: ${u.tin}` : ''} {u.role === 'Admin' ? <span style={{ marginLeft: 6, color: '#b71c1c' }}>• Admin</span> : null}
                  </div>
                </div>
                <div>
                  <input type="radio" name="selectedUser" value={u.id} onChange={() => setSelectedUser(u.id)} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ width: 320 }}>
          <div style={{ fontWeight: 600 }}>Consultants</div>
          <div style={{ maxHeight: 240, overflow: 'auto', border: '1px solid #eee', padding: 8 }}>
            {consultants.length === 0 && <div>No consultants found</div>}
            {consultants.map(c => (
              <div key={c.id} style={{ padding: 6, borderBottom: '1px solid #f2f2f2', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 600 }}>{c.name || c.email} <span style={{ fontSize: 12, color: '#888', marginLeft: 8 }}>#{c.id}</span></div>
                  <div style={{ fontSize: 12, color: '#666' }}>{c.email} {c.role === 'Admin' ? <span style={{ marginLeft: 6, color: '#b71c1c' }}>• Admin</span> : null}</div>
                </div>
                <div>
                  <input type="radio" name="selectedConsultant" value={c.id} onChange={() => setSelectedConsultant(c.id)} />
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 12, textAlign: 'right' }}>
            <button onClick={handleAssign} disabled={assigning} style={{ padding: '8px 12px' }}>
              {assigning ? 'Assigning...' : 'Assign'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultantAssign;